import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { Observable } from 'rxjs/Rx';
import { GridComponent, GridDataResult, DataStateChangeEvent, ColumnComponent, ColumnGroupComponent } from '@progress/kendo-angular-grid'; 
import { CreateEditWindowComponent } from '@app/core/windows/create-edit-window.component';
import { State } from '@progress/kendo-data-query'; 
import { User } from '@app/core/models';
import { BreadCrumbItem } from "@progress/kendo-angular-navigation";


@Component({
  selector: 'app-base-crud',
  template: `OVERRIDES`,
  providers:  [ DatasourceService ]
})
export class BaseCrudComponent implements OnInit {

  @ViewChild(CreateEditWindowComponent, {static: false}) window !: CreateEditWindowComponent;
  
  @ViewChild(GridComponent, {static: false}) grid !: GridComponent;

  protected menu: string = 'MENU';

  protected menuIcon: string = 'gear';

  protected label: string = 'LABEL';

  protected name: string = 'NAME';

  protected nameIcon: string = 'list-unordered';

  protected table: string = 'TABLE';
  
  protected state: State;  

  protected view: Observable<GridDataResult>;

  private allExportedData: Array<any> = [];

  private exludedFields = ['n', 'created', 'modified'];   

  private pageSizes: Array<any> = [
    {text: '5', value: 5}, 
    {text: '10', value: 10}, 
    {text: '20', value: 20}, 
    {text: '50', value : 50},
    {text: 'Todos', value : 0}
  ];
  
  //Variables

  public currentUser: User;

  public breadcrumbItems: BreadCrumbItem[] = [];

  //Eventos

  // @Output() change: EventEmitter<{length: number}> = new EventEmitter();
  
  constructor(protected authService: AuthService, protected service: DatasourceService, protected alertService : AlertService) {
            
    console.log('BaseCrudComponent');
    this.authService.currentUser.subscribe(x => this.currentUser = x);    
    
  }

  protected getBreadcumItems(): BreadCrumbItem[] {
    return [
      {
        icon: "home",
        // disabled: true
      },
      {
        text: this.menu,
        icon: this.menuIcon,
        // disabled: true,
      },
      {
        text: this.name,
        icon: this.nameIcon,
        disabled: false,
      }
    ];
  }
  
  protected dataStateChange(state: DataStateChangeEvent): void {

    this.state = state;
    this.state.sort = this.state.sort.filter(function (sort) {
      return typeof sort.dir != 'undefined';
    });
    this.service.pagination(this.table, this.state);  
    // this.change.emit({length: this.allData.length}); 

  }

  protected addHandler({sender}) {
        
    console.log(this.window, this.label, this.table);
    this.window.create(); 

  }

  protected editHandler({sender, rowIndex, dataItem}) {

    console.log(this.window, this.label, this.table);
    this.window.edit(dataItem, rowIndex);

  }

  protected removeHandler({dataItem}) {
    
    console.log(this.window, this.label, this.table);
    this.window.delete(dataItem);
    
  }

  protected windowSaveHandler({mode, dataItem}) {

    let msg = this.window.getObjectString(dataItem)
    switch(mode){
      case 'CREATE': this.alertService.showAddSuccess(msg); break;
      case 'EDIT': this.alertService.showUpdateSuccess(msg); break;
      case 'DELETE': this.alertService.showDeleteSuccess(msg); break;
    }
    this.service.pagination(this.table, this.state);

  }

  //REMOVER
  protected saveHandler({sender, rowIndex, formGroup, isNew, dataItem}) {

    //REMOVER DE TODOS LOS HMTML.

  }

  //REMOVER
  protected cancelHandler({sender, rowIndex}) {

    //REMOVER DE TODOS LOS HMTML.

  }

  protected refreshHandler(): void {

    this.service.pagination(this.table, this.state);
    
  }

  protected getItemFilter(item: any, value: string) : any {    

    if(item instanceof ColumnComponent && this.exludedFields.indexOf(item.field) == -1){
      return {
        field: item.field,
        operator: 'contains',
        value: value
      };
    }
    return null;

  }

  protected getAllFilters(inputValue: string): any {

    let filters = [];
    let f: any = null;

    this.grid.columns.forEach((item: any, index: number) => {
  
      f = this.getItemFilter(item, inputValue);
      if(f != null) {
        filters.push(f);
      }

      if(item instanceof ColumnGroupComponent){

        item.children.forEach((child: any, index: number) => {
      
          f = this.getItemFilter(child, inputValue);
          if(f != null) {
            filters.push(f);
          }

        });

      }

    });

    return {
      logic: "or",
      filters: filters
    };

  }

  protected onFilter(inputValue: string): void {
    
    console.log('filter', inputValue)
    let s = this.getInitialState();
    s.sort = this.state.sort;
    s.group = this.state.group;    
    
    if(inputValue != null){
      let allFilters: any = this.getAllFilters(inputValue);
      if(allFilters != null){
        if(s.filter.filters.length == 0)
          s.filter = allFilters;
        else {
          s.filter.filters.push(allFilters); 
        }
      }      
    }

    this.state = s;
    this.service.pagination(this.table, this.state);
    
  }

  protected onSearchChange(value: any): void {

    if(value == null)
      this.onFilter(value);
    
  }

  protected onSearchKeyDown(pressedKey): void {

    if (pressedKey.key==="Enter" && pressedKey.target.nodeName == 'INPUT') {
      this.onFilter(pressedKey.target.value);
    }
    
  }

  protected getInitialState() : State {

    return this.service.getStateEmpty();

  }

  public onExcelExport(e: any): void {

    const rows = e.workbook.sheets[0].rows;

    // console.log(e);
    // console.log(rows);

    // align multi header
    //rows[0].cells[2].hAlign = 'center';

    //Primer Round - Agrega las propiedades _column y _columnIndex
    let columns = rows[0].cells;    
    rows.forEach((row) => {
      if (row.type === 'data') {
        row.cells.forEach((cell, i) => {
          if(typeof columns[i] != 'undefined')
            cell._column = columns[i].value;
            // cell._columnIndex = i;
        });
      }
    });

    //Segundo Round - Inicializa la columna '#'
    let index = 0;
    rows.forEach((row) => {
      if (row.type === 'data') {
        index++;
        row.cells.forEach((cell, i) => {
          if(typeof cell._column != 'undefined'){
            switch(cell._column){
              case '#': cell.value = index; break;   
            }
          }          
        });
      }
    });

    this.onCustomExcelExport(e, this.allExportedData);

  }

  protected onCustomExcelExport(e: any, allData: Array<any>): void {
    //Overrides
  }  

  protected async allData() {    

    let s : State = this.getInitialState();
    s.take = 0;
    s.sort = this.state.sort;
    s.filter = this.state.filter;
    s.group = this.state.group;

    const result: any =  {
      data: []
    };

    await this.service.getAllPromise(this.table, s).then((res) => {
      result.data = res.data;
      this.allExportedData = res.data;
      console.log(res);
      // return result;
    })

    return result;

  }

  // public goToLink(url: string) : void {
  //     window.open(url, "_blank");
  // }

  ngOnInit() { 
    
    this.state = this.getInitialState();
    
    this.view = this.service;
    this.service.pagination(this.table, this.state)
    
    this.allData = this.allData.bind(this);

    // this.change.emit({length: 0});


    // let gdr: GridDataResult = this.service as GridDataResult;
    // console.log(gdr.total)
    
  }

}